import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import NominationCard from "./NominationCard";
import { Pagination } from "antd";
import { getEmployeeRewardList } from "../../../../../redux/employeereward/employeeRewardState";

const Nomimations = ({
}) => {
  
  const dispatch = useDispatch();

  const recordList = useSelector((state) => state.employeeReward.employeeRewardList?.items);
  const pagination = useSelector((state) => state.employeeReward.employeeRewardList?.pagination);
  const filters = useSelector((state) => state.employeeReward.employeeRewardList?.filters);

  const doSearch = (filters) => dispatch(getEmployeeRewardList(filters));

  useEffect(() => {
    dispatch(getEmployeeRewardList({ paginate: pagination?.per_page || 10 }));
  }, [dispatch, pagination?.per_page]);

  return (
    <HeaderComponent
      title="Recent Nominations"
      titleClass="text-[16px] font-medium"
      description="Track the status of your reward nominations"
      descriptionClass="text-sm muted-text"
      cardBorder="border"
    >
      <div className="max-h-[600px] overflow-y-auto pr-2">
        <NominationCard 
          recordList={recordList} 
        />

        {pagination?.total > pagination?.per_page && (
          <div className="flex justify-end py-4">
            <Pagination
              current={pagination?.current_page}
              pageSize={pagination?.per_page}
              total={pagination?.total}
              showSizeChanger={false}
              onChange={(page) =>
                doSearch({
                  ...filters,
                  page,
                  paginate: pagination?.per_page,
                })
              }
            />
          </div>
        )}
      </div>
    </HeaderComponent>
  );
};

export default Nomimations;